import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;
export const fetchClientList = createAsyncThunk(
    'client/fetchClient',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'client/sub-client/v1/list', rejectWithValue)
)

export const createUpdateClient = createAsyncThunk(
    'client/createUpdateClient',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/sub-client/v1', rejectWithValue)
)

export const deleteClient = createAsyncThunk(
    'clients/deleteClient',
    (arg, { rejectWithValue }) => DataService.delete(arg, path+`client/sub-client/v1/delete/${arg?.clientId}`, rejectWithValue)
)

export const toggleActivation = createAsyncThunk(
    'clients/toggleActivation',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/sub-client/v1/toggle-status/${arg?.clientId}`, rejectWithValue)
)

export const sendActivationLink = createAsyncThunk(
    'clients/sendActivationLink',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/sub-client/v1/activation-mail/${arg?.clientId}`, rejectWithValue)
)

export const sendResetPasswordLink = createAsyncThunk(
    'clients/sendResetPasswordLink',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/sub-client/v1/send-reset-password/${arg?.clientId}`, rejectWithValue)
)

export const getClientByClientId = createAsyncThunk(
    'clients/getClientByClientId',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/sub-client/v1/single/${arg?.clientId}`, rejectWithValue)
)

export const downLoadReport = createAsyncThunk(
    'clients/downLoadReport',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'client/sub-client/v1/download', rejectWithValue)
)